module.exports = __webpack_public_path__ + "img/cave160.7f251363.jpg";